import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIsMobileForHomePage } from '~/hooks/useIsMobileForHomePage';
import { useLocaleKeys } from '~/i18n';
import styles from './ClientRow.module.scss';
export const GetOwnerCellTID = (parentTestId)=>getTestIds(parentTestId);
export function OwnerCell(param) {
    let { client, testId } = param;
    const { t: texts } = useLocaleKeys('pages.clientsDashboard');
    const isMobileDevice = useIsMobileForHomePage();
    const { OwnerCellTestIds: OID } = useMemo(()=>GetOwnerCellTID(testId), [
        testId
    ]);
    const firstOwner = client.owners[0];
    if (!firstOwner) {
        return /*#__PURE__*/ _jsx(Typography, {
            variant: "paragraph2",
            children: "-"
        });
    }
    const remainingCount = client.owners.length - 1;
    const emailDisplay = isMobileDevice ? "(".concat(firstOwner.email, ")") : firstOwner.email;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 2,
        testId: OID.Root(),
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                ellipsis: true,
                variant: "paragraph2",
                children: [
                    firstOwner.name,
                    remainingCount > 0 && /*#__PURE__*/ _jsxs(Typography, {
                        skin: "secondary",
                        variant: "paragraph2",
                        as: "span",
                        className: styles.ownerMore,
                        children: [
                            ' ',
                            texts.ownerMore({
                                count: remainingCount
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                ellipsis: true,
                skin: "secondary",
                variant: "paragraph3",
                testId: OID.Email(),
                children: emailDisplay
            })
        ]
    });
}
